module.exports = __webpack_public_path__ + "static/media/spicyyellowtail.69457153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/spicyyellowtail.jpg
// module id = 115
// module chunks = 0